import { useCallback, useState } from "react";

export default function useDisclosure() {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const openDialog = useCallback(() => {
    setShowDialog(true);
  }, []);

  const closeDialog = useCallback(() => {
    setShowDialog(false);
  }, []);

  return {
    isOpen: showDialog,
    onOpen: openDialog,
    onClose: closeDialog,
  };
}
